/*
* 车辆油耗管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Select,
    Modal,
    Button,
    Upload,
    Tag,
    Space,
    Statistic,
    theme,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import CarOilEntity from './CarOilEntity';

const Option = Select.Option;
const MODULENAME = CNF.navItems[1].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[2].ptn;

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,
            colorWarning,
            colorWarningBg,
        },
    } = theme.useToken();

    const update = (record) => { props.setOpen(true, record); }
    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'car/oils/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break
            default:
                break;

        }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '车牌号码', dataIndex: 'license_number', key: 'license_number', fixed: 'left', width: 120, },
        { title: '加油卡号', dataIndex: 'oil_card_number', key: 'oil_card_number', },
        { title: '油品类型', dataIndex: 'oil_type_number', key: 'oil_type_number', },

        {
            title: '加油数量(L)', key: 'quantity',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorPrimaryBg}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.quantity} /></Tag>
        },
        {
            title: '实时单价(元)', key: 'price',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorWarningBg}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorWarning }} value={record.price} /></Tag>
        },
        {
            title: '加油金额(元)', key: 'amount',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '60%' : '80%' }} color={colorSuccessBg}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={record.amount} /></Tag>
        },
        { title: '加油时间', dataIndex: 'deal_time', key: 'deal_time', },
        { title: '加油地址', dataIndex: 'oil_address', key: 'oil_address', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        总计：<Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix='L' valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={props.qss?.quantity} /></Tag>
                        <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={props.qss && props.qss.amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={props.qss && props.qss.amount > 10000 ? props.qss.amount / 10000 : props.qss.amount} /></Tag>
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            qss: {},
            carUlid: '',
            licenseNumber: '',
            oilTypeNumber: '',
            carLists: [],

        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeLicenseNumber = (value) => { this.setState({ carUlid: value === undefined ? '' : value }); this.search(); }
    changeOilTypeNumbers = (value) => { this.setState({ oilTypeNumbers: value === undefined ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }
    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'car_ulid': this.state.carUlid,
            'oil_type_number': this.state.oilTypeNumber,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}car/oils${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt,
                            qss: data.qss,
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0,
                            qss: {},
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    uploadCheck = (info) => {
        if (info.size > 10240000) {
            message.error('上传文件超过10M, 建议拆分文件！');
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null) {
            message.error('文件格式不对, 只支持 xls 或 xlsx ！');
            return false
        }
        return true
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    upload = (info) => {
        const _this = this;
        if (info.file.status === 'uploading') {
            message.loading({ content: '文件正在导入...', key: 'import', duration: 0 });
        } else if (info.file.status === 'done') {
            message.success({ content: '文件导入完成！', key: 'import', duration: 1.5 });
            if (info.file.response.dat) {
                setTimeout(function () {
                    Modal.success({
                        title: '导入车辆油耗信息',
                        width: 500,
                        content: (
                            <div style={{ height: '300px', overflow: 'scroll' }}>
                                <Row style={{ lineHeight: 2 }} key={0}>
                                    <Col span={3}>行号</Col>
                                    <Col span={9}>车牌号码</Col>
                                    <Col span={12}>消息说明</Col>
                                </Row>
                                {
                                    info.file.response.dat.length &&
                                    info.file.response.dat.map((item) => {
                                        return (
                                            <Row style={{ lineHeight: 2 }} key={item['key']}>
                                                <Col span={3}>{item['key']}</Col>
                                                <Col span={9}>{item['license_number']}</Col>
                                                <Col span={12}>{item['msg']}</Col>
                                            </Row>
                                        )
                                    })
                                }
                            </div>
                        ),
                        onOk() { _this.isRefresh(); },
                    });
                }, 2000)
            } else {
                message.error(info.file.response.msg, CNF.messageDuration);
            }
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
        }
    }

    /***
    * 导出 Excel
    */
    exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆油耗明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆油耗明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '加油卡号',
                    '油品类型',
                    '加油数量(L)',
                    '实时单价(元)',
                    '加油金额(元)',
                    '加油时间',
                    '加油地址',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出车辆信息明细
     */
    export() {
        const _this = this;
        const params = {
            'car_ulid': this.state.carUlid,
            'oil_type_number': this.state.oilTypeNumber,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}car/oils${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        // 删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['car_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            d.push(item);
                        }
                        _this.exportAsExcel(d);
                    } else {
                        _this.exportAsExcel([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
     * 获取车辆下拉列表
     */
    carDDList = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.setState({ carLists: data.dat });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.carDDList();
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Select
                            showSearch
                            allowClear
                            placeholder='请选择车辆'
                            style={{ width: '100%' }}
                            onChange={this.changeLicenseNumber}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            {
                                this.state.carLists && this.state.carLists.map((item) => {
                                    return <Option key={item.key} value={item.key}>{item.license_number}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: 5 }}>
                        <Select
                            allowClear
                            style={{ width: '100%' }}
                            placeholder='请选择油品'
                            onChange={this.changeOilTypeNumbers}>
                            {
                                CNF.oilTypeNumbers && CNF.oilTypeNumbers.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_import') >= 0 ? (
                                <Upload
                                    action={CNF.api + 'car/oils/lists'}
                                    headers={AddRequestHeaders(false)}
                                    onChange={this.upload}
                                    beforeUpload={this.uploadCheck}
                                    showUploadList={false}
                                    name='file'
                                    accept='xlsx,xls'
                                >
                                    <Button
                                        title={CNF.actionName.IMPORT + MODULENAME}
                                        color='primary'
                                        variant='solid'
                                        icon={<ImportOutlined />}
                                    >
                                        {CNF.actionName.IMPORT}
                                    </Button>
                                </Upload>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <CarOilEntity
                        policy={this.props.policy}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                        carLists={this.state.carLists}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            qss={this.state.qss}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT